export default "/images/162410db8b4d8fd9d0c274ee0f4d34ed.jpg";